import { Button } from '@mui/material';
import styled from 'styled-components';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const RedButton = styled(Button as any)`
  background-color: #ff0057 !important;
  color: white !important;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  padding: 14px !important;
  font-size: 14px !important;
  
  &:hover {
    background-color: #ff0000 !important;
    color: white !important;
  }

  ${(props) =>
    props.disabled &&
    `background: 
  	color: rgba(0, 0, 0, 0.26);
    background: #b3b3b3!important;
    opacity: 0.5;
  ;`};

  &disabed {
    color: rgba(0, 0, 0, 0.26);
    background: #b3b3b3 !important;
    opacity: 0.5;
  }
  
  /* Адаптивность для мобильных устройств */
  @media (max-width: 600px) {
    padding: 10px 12px !important;
    font-size: 13px !important;
    min-width: auto !important;
  }
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const TransparentButton = styled(Button as any)`
  background-color: transparent !important;
  color: black !important;
  box-shadow: none;
  padding: 7px 14px;
  font-size: 14px !important;
  
  /* Адаптивность для мобильных устройств */
  @media (max-width: 600px) {
    padding: 6px 10px !important;
    font-size: 13px !important;
    min-width: auto !important;
  }
`;
